<button (click)="exportMap()" id="map-export-button" [title]="'BUTTON.EXPORT_MAP' | translate" mat-icon-button>
  <mat-icon fontSet="mdi" fontIcon="mdi-printer" class="sm" aria-hidden="true"></mat-icon>
</button>
